import { useEffect } from 'react'
import { useQuery } from 'react-query'
import QueryKeys from '../utils/constants/queryKeys'
import getOrgSubscriptionStatus from '../Apis/subscriptions/getOrgSubscriptionStatus'
import localStorageIds from '../utils/constants/localStorageIds'
import { setLocalStorageValue } from '../utils/helpers/localStorageHelperMethods'

const useOrgSubscriptionStatus = (orgId) => {
  const query = useQuery(
    [QueryKeys.GET_ORG_SUB_STATUS, orgId],
    () => getOrgSubscriptionStatus({ orgId }),
    { enabled: !!orgId },
  )

  // Sync via effect, not onSuccess: onSuccess doesn't run when a mount is
  // served from fresh cache, which would leave another org's status in
  // localStorage after switching orgs.
  useEffect(() => {
    if (query.data !== undefined) {
      setLocalStorageValue([{ id: localStorageIds.SELECTED_ORG_SUB_STATUS, value: query.data }])
    }
  }, [query.data])

  return query
}

export default useOrgSubscriptionStatus
